<script setup>
import { computed } from "vue";
import { cva } from "class-variance-authority";
import { cn } from "@/lib/utils";

// Pills label a thing: a grade, a level, a status. Soft fill, hairline border,
// never a shouty solid — the brand tokens carry the colour.
const badgeVariants = cva(
  "inline-flex items-center gap-1.5 rounded-full border px-2.5 py-1 text-xs font-semibold leading-none [&_svg]:size-3.5",
  {
    variants: {
      variant: {
        default: "border-line-brand bg-brand-soft text-brand-soft-text",
        live: "border-live/30 bg-live-soft text-live-soft-text",
        secondary: "border-line bg-surface-2 text-muted",
        success: "border-success/30 bg-success-bg text-success",
        warning: "border-warning/30 bg-warning-bg text-warning",
        destructive: "border-danger/30 bg-danger-bg text-danger",
        solid: "border-transparent bg-brand text-brand-contrast",
        outline: "border-line text-ink",
      },
    },
    defaultVariants: {
      variant: "default",
    },
  }
);

const props = defineProps({
  variant: { type: String, default: 'default' },
  class: { type: String, default: '' },
});

const calculatedClass = computed(() => {
    return cn(badgeVariants({ variant: props.variant }), props.class)
});
</script>

<template>
  <div :class="calculatedClass">
    <slot />
  </div>
</template>
